module.exports = __webpack_public_path__ + "static/media/responsive.80757c9b.svg";